import { ProblemStatementParamsSchema } from "@playbookai/widget-schemas";

/**
 * The Problem Statement's storable length, read OFF THE SCHEMA rather than
 * written down again (PB-1575).
 *
 * The expanded editor used to hardcode `2000`, which happened to match
 * `LongText` — and a hardcoded UI cap that drifts from the schema is the
 * silent-drop defect all over again in the other direction: the control would
 * accept text the widget then refuses to store. Zod exposes the constraint, so
 * the two cannot disagree.
 */
export const PROBLEM_STATEMENT_MAX_LENGTH: number =
  ProblemStatementParamsSchema.shape.problem.maxLength ?? 2000;
